<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Web Product Admin'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
    <ng-container>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row>
                      <ion-col size="12" size-md="2.8" style="padding-top:25px;padding-left:10px">
                             <ion-row>
                              <span  style="color:white" >Input a few letters of the Product Code.</span>
                            </ion-row>
                        </ion-col>
                        <ion-col  size="12" size-md="6" >
                            <ion-row>
                                <ion-input type="text"  [(ngModel)]="productCode" class="ion-text-left color-light" placeholde="Leave blank for a list of all."></ion-input>
                              </ion-row>
                            
                        </ion-col>
                         <ion-col size="12" size-md="0.8"  >
                             <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="getWebProduct()" ><span>Show</span></ion-button>
                         </ion-col>  
                           </ion-row>
                </ion-grid>

            </ion-row>

            <ion-row class="table-row">
                 <div    #scrollContainer  class="ion-padding table-container">
                    <app-product-report-table  (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" [scrollbarV]="true" 
                     ></app-product-report-table>
                </div>
                
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>
